export default __webpack_public_path__ + "static/media/Eswar Jewellers logo.c941ddb5.png";